import React from "react";
import CustomModalImportWorkshopCourseAttendant from "./CustomModalImportWorkshopCourseAttendant";

export default function CustomModalImportWorkshopCourseAttendantHasAttended(props) {
  return <CustomModalImportWorkshopCourseAttendant {...props} markHasAttended />;
}
